import Grid from "@mui/material/Grid";
import { ReactComponent as Arrow } from "assets/Arrow-Right-small.svg";
import { ReactComponent as ArrowRight } from "assets/Arrow-right-medium.svg";
import Button from "components/common/Button";
import MetricDetails from "components/features/dashboard/MetricDetails";
import { useAppSelector } from "redux/hooks";

import Divider from "@mui/material/Divider";
import ThemeContext from "components/app/Context";
import CustomContainer from "components/common/CustomContainer";
import Typography from "components/common/Typography";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { tokens } from "styles/Tokens";
import { routes } from "utils/routes";
import "./index.scss";
import React from "react";

const SuggestionMetrics = () => {
  const navigate = useNavigate();

  const metrics = useAppSelector((state) => state.hotelUserDashboardSlice.dashboardMetrics);
  const dashboardMetrics = Object.keys(metrics).slice(0, 3);

  const { isMobileScreen }: any = useContext(ThemeContext);
  const isAboveProperty = useAppSelector((state) => state.app.loggedInUserDetails.isAbovePropertyUser);

  const redirectToSuggestedPlans = (metricName?: any) => {
    const stateObj = { showSeeAll: true, showAllPlans: false, backButtonVisible: true };
    const payload = { metrics: [metricName], excludeFocusAreas: false };
    navigate(routes.Library, {
      state: metricName ? { ...stateObj, payload: { ...payload } } : { ...stateObj }
    });
  };

  return (
    <>
      {dashboardMetrics && dashboardMetrics?.length > 0 && (
        <CustomContainer variant="light" className="dashboard-metrics" data-testid="dashboard-metrics">
          <Grid container className="dashboard-metrics-container">
            <Grid className="dashboard-metrics-wrapper">
              {dashboardMetrics?.map((metric: string, index: number) => {
                return (
                  <React.Fragment key={metric}>
                    <div key={metric} className="metrics-item">
                      {" "}
                      <MetricDetails key={metric} metric={metrics[metric]} sx={{ marginX: "4px" }} />
                      {!isAboveProperty && (
                        <div className="metrics-text">
                          <Typography
                            textAlign={"left"}
                            color={tokens.Text.General.Color}
                            onClick={() => redirectToSuggestedPlans(metric)}
                            variant={"label"}
                            showBold
                          >
                            Show all the plans related to this metrics
                          </Typography>

                          <ArrowRight />
                        </div>
                      )}
                    </div>

                    {dashboardMetrics.length > index + 1 && (
                      <Divider
                        sx={{
                          backgroundColor: tokens.Border.General.Secondary,
                          marginTop: "16px"
                        }}
                        className="metrics-divider"
                        orientation={isMobileScreen ? "horizontal" : "vertical"}
                        flexItem
                      ></Divider>
                    )}
                  </React.Fragment>
                );
              })}
              {dashboardMetrics.length < 3 && (
                <Grid className="suggestion-button">
                  <Button
                    onClick={() => redirectToSuggestedPlans("")}
                    label={"See All Suggestions"}
                    variant="secondary"
                    endIcon={<Arrow />}
                  />
                </Grid>
              )}
            </Grid>
          </Grid>
        </CustomContainer>
      )}
    </>
  );
};
export default SuggestionMetrics;
